import ArrowTopRight from './ArrowTopRight'

export default ArrowTopRight
// eslint-disable-next-line import/export
export * from './ArrowTopRight'
